<template>
  <div id="workLine"></div>
</template>
<script>
export default {
  data() {
    return {
      persons: {
        xData: ["06-02", "06-03", "06-04", "06-05", "06-06", "06-07", "06-08"],
        yData: [12, 2, 5, 14, 7, 9, 7],
      },
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
        sort: 1,
        startTime: "",
      },
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start;
      this.searchItem.endTime = v.end;
      this.getTime();
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.upf + "/screen/countLoginDay",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data.dataList;
        this.persons.xData = [];
        this.persons.yData = [];
        for (let i = 0; i < data.length; i++) {
          data[i].date = this.utils.time(data[i].date, "mmdd");
          this.persons.xData.push(data[i].date);
          this.persons.yData.push(data[i].loginNum);
        }
        
        
      });
    },
    drawBar(obj) {
      this.chart = this.echarts.init(
        document.getElementById("workLine"),
        "dark"
      );
      this.option = {
        backgroundColor: "",
        grid: {
          x: 30,
          y: 20,
          x2: 30,
          y2: 80, //距离下边的距离
        },
        dataZoom: [
          {
            type: "inside",
            //type: "slider",
            start: 0, //放大起点
            //end: this.list.length<500?100:100/(this.list.length/500) //放大终点
            end: 100, //放大终点
          },
        ],
        xAxis: {
          type: "category",
          data: obj.xData,
          axisLabel: { rotate: 45 },
        },
        yAxis: {
          type: "value",
        },
        color: "#59ddfe",
        series: [
          {
            data: obj.yData,
            type: "line",
            label: {
              show: true,
              position: "top",
            },
            areaStyle: {
              //color: "#ff7c25",
              opacity: "0.9",
              //shadowColor: "#000",
              // shadowBlur: 50,
              //shadowOffsetX:0,
              // shadowOffsetY:-10
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#2c94e5",
                },
                {
                  offset: 1,
                  color: "#132230",
                },
              ]),
            },
          },
        ],
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return val.name + "：" + val.value + "次";
          },
        },
      };
      this.chart.setOption(this.option);
    },
    getTime() {
      var date = Date.now();
      var arr = [];
      for (let i = 7; i > 0; i--) {
        var m = this.utils.time(date - 86400000 * i, "mmdd");
        arr.push(m);
      }
      this.persons.xData = arr;
      setTimeout(() => {
        this.drawBar(this.persons);
      }, 200);
      
    },
  },
  mounted() {
    this.getTime();
  },
};
</script>
<style lang="">
#workLine {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/control/paigongzonglan.vue